<template>
  <div id="features-wrap">
    <h2>{{ characterName ? characterName : 'Features' }} {{ characterClass && characterName ? `the ${ characterClass }`: '' }}</h2>
    <input
      type="text"
      placeholder="Name"
      name="characterName"
      class="character-name"
      v-model="characterName"
    />
    <select name="character" class="character-class" v-model="characterClass">
      <option value disabled>Class</option>
      <option v-for="classers in characterClasses" :key="classers" :value="classers">{{ classers }}</option>
    </select>
    <p style="font-size: 12px; margin: 0 0 1.5em;">
      <em>Changing the class will remove all spells and moves of your character.</em>
    </p>
    <!-- <input type="text" placeholder="Class" name="characterClass" class="character-class" v-model="characterClass"> -->
    <CharacterLeveling />
    <CharacterLook />
    <CharacterAlignment />
    <CharacterBonds />
    <CharacterRace />
    <SaveButtons @clear="clearCharacter" />
  </div>
</template>

<script>
import CharacterLeveling from "./CharacterLeveling.vue";
import CharacterLook from "./CharacterLook.vue";
import CharacterAlignment from "./CharacterAlignment.vue";
import CharacterBonds from "./CharacterBonds.vue";
import CharacterRace from "./CharacterRace.vue";
import SaveButtons from "../../util/SaveButtons";

import { mapGetters } from "vuex";

import util from "../../util/util.js";

// (√)Name, (√)Level, (√)XP, (√)Look (include images slots), (√)Alignment, (√)Bonds, (√)Race
export default {
  name: "Features",
  components: {
    CharacterLeveling,
    CharacterLook,
    CharacterAlignment,
    CharacterBonds,
    CharacterRace,
    SaveButtons
  },
  methods: {
    clearCharacter() {
      this.$store.dispatch("clearCharacterFeatures");
    }
  },
  computed: {
    characterName: {
      get() {
        return this.$store.state.character.name;
      },
      set(value) {
        this.$store.commit("updateCharacterProperty", {
          type: "name",
          property: value
        });
      }
    },
    characterClass: {
      get() {
        return util.capitalize(this.$store.state.character.class);
      },
      set(value) {
        this.$store.dispatch("updateCharacterClass", value.toLowerCase());
      }
    },
    ...mapGetters({
      characterClasses: "getCapitalizedClasses"
    })
  }
};
</script>

<style lang="css">
#features-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
}

#features-wrap > h2 {
  margin-bottom: 0.5em;
}

.character-name,
.character-class {
  width: 80%;
  padding: 0.5em;
  margin-bottom: 1em;
  border: 1px solid #2c3e50;
  border-radius: 3px;
}

.character-class {
  width: 85%;
  font-size: 20px;
  margin-bottom: 0.5em;
}

.character-class:focus {
  outline: none;
}

input {
  font-size: 20px;
}

input:focus {
  outline: 0;
}
</style>